import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "admin-category-list py-56" }
const _hoisted_2 = { class: "d-flex mb-56 justify-content-between" }
const _hoisted_3 = { class: "h4 text-primary mb-0" }
const _hoisted_4 = { class: "fw-normal" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", {
  class: "icon icon-add-ring me-8",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_6 = { class: "card" }
const _hoisted_7 = { class: "flex flex-wrap gap-2" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", {
  class: "icon icon-trash",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_9 = { class: "fw-normal" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Column = _resolveComponent("Column")!
  const _component_v_button = _resolveComponent("v-button")!
  const _component_TreeTable = _resolveComponent("TreeTable")!
  const _component_the_admin_resource_category_create = _resolveComponent("the-admin-resource-category-create")!
  const _component_the_admin_resource_category_destroy = _resolveComponent("the-admin-resource-category-destroy")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h2", _hoisted_3, [
          _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t('Listado de')), 1),
          _createTextVNode(" " + _toDisplayString(_ctx.$t('Categorías recursos').toLowerCase()), 1)
        ]),
        (_ctx.can('admin.video-category.store'))
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 0,
              to: { name: 'admin.resource-category.store' },
              class: "btn btn-secondary btn-icon btn-sm",
              "aria-label": _ctx.$t('Nueva categoría'),
              onClick: _ctx.loadCategories
            }, {
              default: _withCtx(() => [
                _hoisted_5,
                _createTextVNode(" " + _toDisplayString(_ctx.$t('Nueva categoría')), 1)
              ]),
              _: 1
            }, 8, ["to", "aria-label", "onClick"]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_TreeTable, { value: _ctx.nodes }, {
          default: _withCtx(() => [
            _createVNode(_component_Column, {
              field: "label",
              header: "Categoría",
              expander: ""
            }),
            _createVNode(_component_Column, {
              field: "label_select",
              header: "Ruta"
            }),
            _createVNode(_component_Column, {
              headerStyle: "width: 8rem",
              header: "Acciones"
            }, {
              body: _withCtx((nodes) => [
                _createElementVNode("div", _hoisted_7, [
                  (_ctx.can('admin.video-category.store'))
                    ? (_openBlock(), _createBlock(_component_v_button, {
                        key: 0,
                        variant: "icon",
                        class: "btn-sm justify-content-center d-flex flex-column p-0",
                        onClick: ($event: any) => (_ctx.openCategoryModal(nodes, 'the-admin-resource-category-destroy'))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_8,
                          _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t('Eliminar')), 1)
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["value"])
      ])
    ]),
    (_ctx.modalToShow === 'the-admin-resource-category-create')
      ? (_openBlock(), _createBlock(_component_the_admin_resource_category_create, {
          key: 0,
          professional: _ctx.selectedCategory,
          onClosed: _cache[0] || (_cache[0] = ($event: any) => {_ctx.modalToShow = null;
  _ctx.selectedCategory = null;}),
          onProfessionalCreated: _ctx.loadCategories
        }, null, 8, ["professional", "onProfessionalCreated"]))
      : _createCommentVNode("", true),
    (_ctx.modalToShow === 'the-admin-resource-category-destroy')
      ? (_openBlock(), _createBlock(_component_the_admin_resource_category_destroy, {
          key: 1,
          category: _ctx.selectedCategory,
          onClosed: _cache[1] || (_cache[1] = ($event: any) => {_ctx.modalToShow = null;
  _ctx.selectedCategory = null;}),
          onProfessionalDestroyed: _ctx.loadCategories
        }, null, 8, ["category", "onProfessionalDestroyed"]))
      : _createCommentVNode("", true)
  ], 64))
}